import { SidesheetRoutes, useSidesheet } from 'app/shared-components/sidesheets/SidesheetProvider';

function useSidesheetById(sidesheetId: SidesheetRoutes) {
  const { sidesheets } = useSidesheet();

  return sidesheets[sidesheetId];
}

export default useSidesheetById;
